import moment from 'moment';

type Value = string | moment.Moment | Date | null | undefined;

type DateFormat = string;

export const date2str = (value: Value, format: DateFormat = 'YYYY-MM-DD'): string => {
  if (value) {
    const momentObj = moment.isMoment(value) ? value : moment(value);
    if (!momentObj.isValid()) {
      console.warn('Invalid date:', value);
      return '';
    }
    const year = momentObj.year();
    const str = momentObj.format(format);
    if (str === 'Invalid date' || year === 1) {
      return '';
    }
    return str;
  }

  return ''; // Return empty if value is undefined or null
};

export const utc2str = (value: Value, format: DateFormat = 'YYYY-MM-DD'): string => {
  if (value) {
    const momentObj = moment.isMoment(value) ? value : moment.utc(value);
    const year = momentObj.year(); // 0001-01-01 00:00:00 is default date from dotnet ef
    const str = momentObj.local().format(format);
    if (str === 'Invalid date' || year === 1) {
      return '';
    } else {
      return str;
    }
  }
  return '';
};

export const datetime2str = (value: Value, format: DateFormat = 'YYYY-MM-DD | hh:mm A'): string => {
  return utc2str(value, format);
};

export const str2date = (dateStr: string, format: DateFormat = 'YYYY-MM-DD'): Date | null => {
  if (dateStr.toLowerCase() === 'today') {
    return new Date(moment().format(format));
  } else {
    const date = moment(dateStr).format(format);
    if (date === 'Invalid date') {
      return null;
    } else {
      return new Date(date);
    }
  }
};

export const dateAdd = (dateStr: string, days: number): Date => {
  const date = moment(dateStr).add(days, 'days').format();
  return new Date(date);
};
